import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';
import { useHistory } from "react-router-dom";
import { postajob , getProfileDetail, getExperiences, getEducations } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

//import ReactToPrint from 'react-to-print';

import 'react-rangeslider/lib/index.css'

const IMG_URL = "https://api.bewise.in/"; //"https://api.bewise.in/";

class WctalentViewProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export',
      blockinstopenmodal:false,
      suggestions: [],
      institute:'',
      pickedones:[],
      pickedinstIds:[],
      salary_range_forthisjob: 15000,
      userinfo:[],
      experiences:[],
      educations:[],
      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true
    }

    this.teacher_id = this.props.match.params.id;
    this.jobid = this.props.match.params.jobid;
    

  }
 

  componentDidMount() {

          var THIS = this;
  
          this.getProfileData();

           this.getExperiences();
           this.getEducations();

           
          
  }

  getExperiences(){

    let req = JSON.stringify({
      id:this.teacher_id
    })
    
    getExperiences(req).then((response) => {
      
      if(response.status==1){
                  
            this.setState({experiences:response.list})

      } else{
            this.setState({experiences:[]});
      }

    });


  }


  getEducations(){

    let req = JSON.stringify({
      id:this.teacher_id
    })
    
    getEducations(req).then((response) => {
      
      if(response.status==1){
                  
            this.setState({educations:response.list})

      } else{
            this.setState({educations:[]});
      }

    });


  }

  getProfileData(){

    let req = JSON.stringify({
      teacher_id:this.teacher_id
    })
    
    getProfileDetail(req).then((response) => {
      
      if(response.status==1){
                  
            this.setState({userinfo:response.results[0]})

      } else{
            this.setState({userinfo:[]});
      }

    });


  }

  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };

 

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
 

 
  
 
  render() {

        const { userinfo, experiences, educations } = this.state;
         

        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                    

                    <div class="wc-column c80">
                            <div class="option-section pdfcontainer job-card-parent"   style={{backgroundImage:`url('/images/watermark.png')`}} ref={(response) => (this.componentRef = response)} >

                                    <div class="tophead wc-row">
                                         <div class="wc-column c40">

                                          <div class="equalflexrow">
                                                    <div class="wiseconnet_logo"><img src="/images/wiseconnect_980.jpg" width={"250px"}/></div>
                                                    <div class="middle_text">Teacher Profile</div>
                                                    <div class="bewise_logo"><img src="/images/bewiseLogo.png"/></div>

                                          </div>
                                          <div class="borderedboxplain">
                                                <div class="boxtitle"><img src="../../../../images/profile/about.png" />Personal Info</div>
                                                <div class="viewprofile_rowflex">


                                                <div class="profilephoto">
                                                    <span> <img class="job-card-child profileface" alt="" src={IMG_URL+userinfo.profilephoto} /> </span>
                                                </div>

                                                <div class="positionbox flexed">   
                                                        <div class="perinfo">
                                                            <span class="name">Name: <b>{userinfo.name}</b></span>
                                                            <span class="name">Email: <b>{userinfo.email_id}</b></span>
                                                            <span class="name">Phonenumber: <b>{userinfo.phonenumber}</b></span>
                                                            <span class="name">Location: <b>{(userinfo.location=='')?"N/A":userinfo.location}</b></span>
                                                        </div>
                                                        <div class="carinfo">
                                                            <span class="role">Role: <b>{userinfo.job_role}</b></span>
                                                            <span class="role">Subjects: <b>{userinfo.job_subject_teaching}</b></span>
                                                            <span class="role">Job Level: <b>{userinfo.job_levels}</b></span>  
                                                            <span class="role">Total Experience: <b>{userinfo.total_years_experiece} year(s)</b></span>
                                                            <span class="role">Salary Range: <b>Rs.{userinfo.salary_range}</b></span>
                                                            <span class="role">Area of Interests: <b>{userinfo.area_of_interests}</b></span>
                                                        </div>   
                                                </div>

                                                </div>
                                            </div>
                                         </div>       
                                         <div class="wc-column c60">
                                           
                                            <div class="borderedboxplain">
                                                   
                                                    <div class="boxtitle"><img src="../../../../images/profile/about.png" />About Me</div>
                                                    <div class="boxdesc" dangerouslySetInnerHTML={{__html:userinfo.aboutme}}>
                                                    </div>
                                                   
                                            </div>       

                                         </div>

                                         <div class="wc-column c60">
                                           
                                           <div class="borderedboxplain">
                                                  
                                                   <div class="boxtitle"><img src="../../../../images/profile/about.png" />Experience</div>
                                                   <div class="boxdesc">
                                                     {experiences.map((item, i)=>{

                                                        return (
                                                          <div class="flexrowexp">
                                                          <div>{item.school}</div> 
                                                          <div>{item.start_date}-{item.end_date}</div>
                                                          </div> 
                                                          )

                                                     })}
                                                       
                                                   </div>

                                                   
                                           </div>       

                                        </div>

                                        <div class="wc-column c60">
                                           
                                           <div class="borderedboxplain">
                                                  
                                                   <div class="boxtitle"><img src="../../../../images/profile/about.png" />Education</div>
                                                   <div class="boxdesc">
                                                   

                                                        {educations.map((item, i)=>{

                                                        return (
                                                          <div class="flexrowexp">
                                                          <div>{item.school}</div> 
                                                          <div>{item.degree}</div>
                                                          <div>{item.start_date}-{item.end_date}</div>
                                                          </div> 
                                                          )

                                                        })}


                                                   </div>

                                                   
                                           </div>       

                                        </div>

                                        <div class="equalflexrowbtm">
                                                    <div class="wiseconnet_url"><span>https://wiseconnect.bewise.in</span></div>
                                                    <div class="middle_text_copyright">Copyrights @bewise</div>
                                                    <div class="bewise_url"><span>https://www.bewise.in</span></div>

                                          </div>

                                    </div>

                                    
                                    
                            </div>  
                            { /*
                            <ReactToPrint
                                        content={() => this.componentRef}
                                        trigger={() => <button className="btn btn-primary">Download This Profile</button>}
                                                      />*/ }
                              
                        </div> 


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default WctalentViewProfile;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/viewprofile.jsx